import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, Group, CreateGroupFromGroupDto, IRow, TagRenamingStrategy, KeyValuePair } from '../../../../models';
import { ILoggerService, IStoreService } from '../../../../services';
import { defaultTagRenamingStrategies, groupAdded, groupForbiddenCharacters, groupForbiddenStartingCharacters } from '../../../../common';

interface IDuplicateFormCtrl extends angular.IFormController {
    newGroupName: angular.INgModelController;
}

class DuplicateGroupModalController implements angular.IComponentController, angular.IOnChanges {
    defaultTagRenamingStrategies: KeyValuePair<TagRenamingStrategy, string>[] = defaultTagRenamingStrategies;
    formController: IDuplicateFormCtrl;
    includeSubGroups: boolean;
    isLoaded: boolean;
    isLoading: boolean;
    newGroupName: string;
    newGroupParentGuid: string;
    placement: string = 'bottom-left';
    rows: IRow[];
    tagRenamingStrategy: TagRenamingStrategy;

    readonly group: Group;
    readonly groups: Group[];
    readonly modalId: string;

    static $inject = [
        '$rootScope',
        '$timeout',
        'storeService',
        'loggerService'
    ];

    constructor(
        private _$rootScope: angular.IRootScopeService,
        private _$timeout: angular.ITimeoutService,
        private _storeService: IStoreService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this.rows = [];
    }

    $onChanges(changes: angular.IOnChangesObject): void {
        if (changes['group']?.currentValue) {
            this.newGroupName = this.group.name;
            this.newGroupParentGuid = this.group.parentGUID;
            this.tagRenamingStrategy = TagRenamingStrategy.GenerateTagNames;
            this._$timeout(() => this.validateName());
        }
    }

    changeParent(): void {
        this._$timeout(() => this.validateName());
    }

    createFrom() {
        const data: CreateGroupFromGroupDto = {
            guid: this.group.guid,
            replacements: this.rows,
            newName: this.newGroupName,
            includeSubGroups: !!this.includeSubGroups,
            parentGroupGuid: this.newGroupParentGuid,
            tagRenamingStrategy: this.tagRenamingStrategy
        };
        this._storeService
            .dispatchers()
            .groups
            .duplicate(data)
            .then(groups => {
                this._loggerService.logSuccess('Group successfully created!');
                if (groups?.length) {
                    const found = groups.filter(g => g.guid === this.group.guid);
                    if (found) {
                        this._$rootScope.$broadcast(groupAdded, found);
                    }
                }
            })
            .catch(reason => {
                console.log(reason);
                this._loggerService.logError('Failed to create group');
            })
            .finally(() => {
                this.formController.$setPristine();
                this.newGroupName = '';
                this.rows = [];
            });
        return true;
    }

    validateName() {
        this.checkForbidden();
        this.checkDuplicate();
    }

    private checkForbidden() {
        if (this.formController && this.formController.newGroupName) {
            const newName = this.formController.newGroupName.$viewValue?.toLowerCase();
            const isValid = !_.some(newName, c => groupForbiddenCharacters.indexOf(String(c)) >= 0)
                && !_.some(groupForbiddenStartingCharacters, c => _.startsWith(newName, c));
            this.formController.newGroupName.$setValidity('forbidden', isValid);
        }
    }

    private checkDuplicate() {
        if (this.formController && this.formController.newGroupName) {
            const isValid = !_.some(this.groups, t => t.parentGUID === this.newGroupParentGuid
                && t.name?.toLowerCase() === this.formController?.newGroupName?.$viewValue?.toLowerCase());
            this.formController.newGroupName.$setValidity('duplicate', isValid);
        }
    }
}

export const wtDuplicateGroupModal: ComponentDefinition = {
    componentId: 'wtDuplicateGroupModal',
    controller: DuplicateGroupModalController,
    template: require('./duplicateGroupModal.component.html'),
    controllerAs: 'vm',
    bindings: {
        group: '<',
        groups: '<',
        modalId: '@'
    }
};